import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TextButton from 'components/TextButton';
import IconClose from 'resources/icon-close-white.svg';
import IconCloseNew from 'resources/Icon-Close-Btn.png';
import './CloseButton.css';

function CloseButton({ url, onClick, className, urlIcon }) {
  return url ? (
    <div className={'close-button-component ' + (className || '')}>
      <Link to={url}>
        <img src={IconCloseNew} alt="Close" />
      </Link>
    </div>
  ) : (
    <div className={'close-button-component ' + (className || '')}>
      <TextButton onClick={onClick}>
        <img src={urlIcon ? IconCloseNew : IconClose} alt="Close" />
      </TextButton>
    </div>
  );
}

CloseButton.propTypes = {
  url: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  urlIcon: PropTypes.bool
};

export default CloseButton;
